import { PubNubMessageKey, PubnubMessage } from './types';

export const parseEvent = (message: any): PubnubMessage | null => {
  try {
    const parsedMessage = JSON.parse(message);

    if (parsedMessage.long_message_id) {
      return {
        key: PubNubMessageKey.LongMessage,
        data: { longMessageId: parsedMessage.long_message_id },
      };
    }

    const { key, data: parsedData } = parsedMessage;
    let data = parsedData;

    try {
      // Sometimes the data is double encoded
      data = typeof data === 'string' ? JSON.parse(data) : data;
    } catch {
      // Leave data as is
    }

    if (__DEV__) {
      console.log('Parsed pubnub message', key, data);
    }

    if (!key || !data) {
      return null;
    }

    return { key, data };
  } catch (err) {
    console.error('Failed to parse pubnub message', err);
    return null;
  }
};
